/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaHome } from "react-icons/fa";
import sabcco_logo from "../../../assets/SABCCO_128x128.png";
import { useSelector } from "react-redux";

import {
  FiShield,
  FiInfo,
  FiSmartphone,
  FiSend,
  FiCheckCircle,
} from "react-icons/fi";

import { Link, useNavigate } from "react-router-dom";

import {
  MANAGE_OTP_DETAILS_URL,
  RAS_KEY_URL,
} from "../../../api/api_routing_urls";
import rsa from "../../../utilities/rsaFunction/rsaEncryption";
import Input from "../../../reusable-components/inputs/InputTextBox/Input";
import HeroBanner from "../../../reusable-components/hero_banners/HeroBanner";
import H1 from "../../../reusable-components/headings/H1";
import axios from "../../../api/axios";
import { useLocation } from "react-router-dom";

// import { useDispatch } from "react-redux";
// import { setCompleteLoaneeDetails } from "../../../../features/loaneeDetails/LoaneeDetails";

const { rsaEncrypt } = rsa;

export default function NocApplicantVerifyOtpPage() {
  const location = useLocation();
  // const { completeLoaneeDetails } = useSelector((state) => state.loaneeDetails);

  const [showOtpSentText, setShowOtpSentText] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isVerifyingText, setIsVerifyingText] = useState(false);
  const [verificationFailStatus, setVerificationFailStatus] = useState(false);

  const navigate = useNavigate();

  // const dispatch = useDispatch();

  const defaultValues = {
    phone_number: "",
    session_otp: "",
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    criteriaMode: "all",
    defaultValues: defaultValues,
  });

  const getPublicKeyRsa = async () => {
    try {
      const response = await axios.get(RAS_KEY_URL);
      if (response?.data?.status === 201) {
        console.log("RAS_KEY_URL", response?.data?.rsa_detail);

        return response?.data?.rsa_detail;
      } else {
        return;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onSubmitVerify = async (data) => {
    console.log("data", data);
    setIsVerifyingText(true);
    const { publicKey, session_uuid } = await getPublicKeyRsa();
    console.log("publicKey", publicKey);

    // try {
    //   const test_otp = rsaEncrypt("1234", publicKey);
    //   console.log({ test_otp });
    // } catch (error) {
    //   console.error(error);
    // }

    if (publicKey !== undefined && publicKey !== null && publicKey !== "") {
      const encryptedOtp = rsaEncrypt(data?.session_otp, publicKey);

      try {
        let sendDataObj = {
          phone_number: `${applicantDetails?.phoneNo}`,
          // phone_number: `7872279905`,
          session_otp: encryptedOtp,
          session_uuid: session_uuid,
        };

        let response = await axios.post(
          `${MANAGE_OTP_DETAILS_URL}/verifyOtpRepaymentOnline`,
          sendDataObj,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          },
        );

        console.log(
          "response to check accessToken",
          response?.data?.accessToken,
        );

        if (response.status === 200) {
          setVerificationFailStatus(0);

          // navigate("/noc-online-payment");

          navigate("/noc-online-payment", {
            state: { applicantDetails },
          });
        } else {
          console.log("OTP entered is wrong.", "error");
          setVerificationFailStatus(1);
          if (response.data.userdetails.includes("unique_user_phone_number")) {
            console.log("This entry already exists.", "error");
          } else {
            console.log(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
              "error",
            );
          }
          return;
        }
        reset();
      } catch (error) {
        // ... (existing catch block remains unchanged)
      } finally {
        setIsVerifyingText(false);
      }
    } else {
      console.error(
        "Encryption error in login due to absence of rsaPublicKey!",
      );
    }
  };

  const onSubmitOtpClick = async () => {
    console.log("onSubmitOtpClick");
    setShowOtpSentText(true);
    try {
      let sendDataObj = {
        phone_number: ` ${applicantDetails.phoneNo}`,
        // phone_number: "7872279905",
      };

      console.log("phone number", sendDataObj?.phone_number);
      let response = "";
      response = await axios.post(`${MANAGE_OTP_DETAILS_URL}`, sendDataObj);
      console.log("response", response);
      if (response?.status === 200) {
        setShowOtpInput(true);
      } else {
        console.log("Phone Number could not be verified. Please try again.");
        if (response.data.userdetails.includes("unique_phone_number")) {
          console.log("This entry already exists.");
        } else {
          console.log(
            "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
            "error",
          );
        }
        return;
      }
      reset();
    } catch (error) {
      if (!error?.response) {
        console.log("No Server Response", "error");
      } else if (error.response.status === 422) {
        console.log("Some of the required inputs were not provided.", "error");
      } else {
        console.log(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error",
        );
      }
    }
  };

  const { applicantDetails } = location.state || {};

  // console.log("applicantDetails", applicantDetails);

  return (
    <section>
      <HeroBanner>
        <div className="absolute left-10 right-10 top-1/2 md:left-14 md:right-14 lg:left-1/5 lg:right-10">
          <div className="text-center">
            <H1>Verify One-Time Password</H1>
          </div>
        </div>
      </HeroBanner>

      <section className="my-12 min-h-screen">
        <div className="mx-auto w-11/12 md:w-3/4 lg:w-1/2 xl:w-2/5">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-lg">
            {/* Header */}
            <div className="bg-primary p-8 text-center text-white">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/20">
                <FiShield className="h-7 w-7" />
              </div>

              <p className="mt-2 text-sm text-white/90 text-center">
                Enter the OTP sent to your mobile number to continue.
              </p>
            </div>

            {/* Body */}
            <div className="p-8">
              {/* Mobile Number */}
              <div className="mb-6 rounded-lg border border-blue-200 bg-blue-50 p-4">
                <div className="flex items-start gap-3">
                  <FiSmartphone className="mt-1 h-5 w-5 text-blue-600" />

                  <div>
                    <p className="text-sm font-semibold text-blue-900">
                      OTP will be sent to
                    </p>

                    <p className="mt-1 text-lg font-bold text-primary">
                      {applicantDetails?.phoneNo}
                    </p>

                    <p className="mt-2 text-sm text-blue-800">
                      Please keep your phone nearby to receive the verification
                      code.
                    </p>
                  </div>
                </div>
              </div>

              {/* Send OTP */}
              {!showOtpSentText ? (
                <button
                  onClick={onSubmitOtpClick}
                  className="flex w-full items-center justify-center rounded-lg bg-primary px-6 py-3 font-semibold text-white shadow-sm transition hover:bg-primary/90 hover:shadow-lg"
                >
                  <FiSend className="mr-2 h-5 w-5" />
                  Send OTP
                </button>
              ) : (
                <div className="mb-6 rounded-lg border border-green-200 bg-green-50 p-4">
                  <div className="flex items-center gap-3">
                    <FiCheckCircle className="h-5 w-5 text-green-600" />

                    <p className="text-sm font-medium text-green-700">
                      OTP has been sent successfully. Enter it below to
                      continue.
                    </p>
                  </div>
                </div>
              )}

              {/* Error */}
              {verificationFailStatus === 1 && (
                <div className="mb-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
                  The OTP you entered is incorrect. Please try again.
                </div>
              )}

              {/* OTP Form */}
              {showOtpInput && (
                <form
                  onSubmit={handleSubmit(onSubmitVerify)}
                  className="space-y-6"
                >
                  <Input
                    defaultName="session_otp"
                    register={register}
                    name="One-Time Password"
                    required={true}
                    pattern={null}
                    errors={errors}
                    placeholder="Enter the 6-digit OTP"
                    setError={setError}
                    clearError={clearErrors}
                    autoComplete="one-time-code"
                    type="text"
                    classes="w-full rounded-lg border-gray-300 px-4 py-3"
                    onChangeInput={null}
                    setValue={setValue}
                  />

                  <button
                    type="submit"
                    className="flex w-full items-center justify-center rounded-lg bg-primary px-6 py-3 font-semibold text-white shadow-sm transition hover:bg-primary/90 hover:shadow-lg"
                  >
                    {isVerifyingText ? "Verifying..." : "Verify OTP"}
                  </button>
                </form>
              )}

              {/* Footer */}
              <div className="mt-8 rounded-lg border border-gray-200 bg-gray-50 p-4">
                <div className="flex items-start gap-3">
                  <FiInfo className="mt-1 h-5 w-5 text-gray-600" />

                  <p className="text-sm text-gray-700">
                    If you do not receive the OTP within a few minutes, please
                    ensure the mobile number is reachable and try sending the
                    OTP again.
                  </p>
                </div>
              </div>

              <div className="mt-8 flex justify-center">
                <Link
                  to="/"
                  className="text-sm font-medium text-primary transition hover:underline"
                >
                  ← Back to Website
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}
